export const preOrderParamsPersistField = [
  'preOrderParams',
  'couponOptimalItemRequests',
  'couponInfo',
  'hasMoreCoupons'
];
export const preOrderParamsSessionFieId = ['supplyId'];

export const order = {
  namespaced: true,
  root: true,
  state: {
    supplyId: '',
    preOrderParams: {},
    payInfo: {},
    historyNum: 0,
    couponInfo: {},
    couponOptimalItemRequests: [],
    hasMoreCoupons: false,
    smartCouponId: 61,
    siderbarActive: 0
  },
  mutations: {
    setPreOrderParams(state, preOrderParams) {
      state.preOrderParams = preOrderParams;
    },
    setPayInfo(state, info) {
      state.payInfo = info;
    },
    setSupplyId(state, id) {
      state.supplyId = id;
    },
    setCouponInfo(state, info) {
      state.couponInfo = info;
    },
    setCouponOptimalItemRequests(state, info) {
      state.couponOptimalItemRequests = info;
    },
    setHasMoreCoupons(state, info) {
      state.hasMoreCoupons = info;
    },
    setSiderbarActive(state, info) {
      state.siderbarActive = info;
    }
  }
};
